import { render } from "./App.vue?vue&type=template&id=094de0fc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=094de0fc&lang=scss"

import exportComponent from "/Users/andremichaelis/Websites/gmf.goldspruch/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__